
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.5 15a4.5 4.5 0 100 9 4.5 4.5 0 000-9zm-.469 6.484l-1.688-1.637.695-.697.992.94 2.115-2.169.697.696-2.811 2.867zM14 6h1V0h-3v1H9v1h3v1h2v3zm-1-4V1h1v1h-1zm-1 4h-1V4H9V3h3v1h1v1h-1v1zM6 6H2V2h4v4zm17 5h-1V9h-1v3.169a7.41 7.41 0 00-1.071-.134L20 12v-1h-1v-1h-2V9h-1v1h-1V9h-1v1h-1V9h-1v1h-1v1h-1v-1h1V9H7v1h2v1H7v1h1v2h1v-1h2v2h1v-4h1v2h2.77a7.52 7.52 0 00-2.9 3H11v1h1.436a7.536 7.536 0 00-.413 2H11v-2h-1v1H9v6h5.82A6.474 6.474 0 0113 19.5c0-3.568 2.913-6.5 6.5-6.5 1.642 0 3.226.62 4.456 1.782l.044.039V13h-.801L23 12.874V12h1v-2h-1v1zm-8 1h-1v-1h1v1zm-3 11h-2v-1h1v-1h-1v-1h2.031a7.413 7.413 0 00.843 3H12zm6-11h-1v-1h1v1zm-8-5H9V6h2v2h-1V7zm12-1h-4V2h4v4zm-9 0h1v1h-1V6zm3-6v8h8V0h-8zm7 7h-6V1h6v6zM12 7h1v1h-1V7zm2 1V7h1v1h-1zm-4 7v2H9v-2h1zm-3-5v1H6v-1h1zm13 0h-1V9h1v1zM6 9v1H4v1h1v1H2v-1h1v-1H1v1H0V9h6zM0 24h8v-8H0v8zm1-7h6v6H1v-6zm6-3h1v1H7v-1zm-5 4h4v4H2v-4zm3-5v-1h1v3H5v-1H4v1H3v-1H2v1H0v-1h1v-1h4zm-4-1v1H0v-1h1zM8 0H0v8h8V0zM7 7H1V1h6v6z"}})])
          )
        }
      }
    